import axiosInstance from "../config/axiosInterceptor";

export async function getDashboardWidgets(projectName = null) {
  const params = projectName ? { projectName } : {};
  return await axiosInstance.get("/api/Dashboard/GetDashboardWidgets", { params });
}

export async function getOnlineNodeWidget() {
  return await axiosInstance.get("/api/Dashboard/GetOnlineNodeWidget");
}

export async function getListById(listId, nodeId = null) {
  const url = nodeId
    ? `/api/Dashboard/GetListById/${listId}/${nodeId}`
    : `/api/Dashboard/GetListById/${listId}`;
  return await axiosInstance.get(url);
}
